export function driverTaxIdFieldLabel(
  billingCountry: string | null | undefined,
): string {
  const c = billingCountry?.trim().toLowerCase();
  if (!c) return "Tax ID";
  if (c === "ie" || c === "irl" || c === "ireland") return "PPS Number";
  return "Tax ID";
}
